import Loading from "components/loading/Loading";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";

export const TutorialPlayerEmbeds: React.FC = () => {
    const user = useSelector((state: RootState) => state.user);
    const horizontalEmbedRef = useRef<HTMLDivElement>(null);
    const verticalEmbedRef = useRef<HTMLDivElement>(null);
    const [isLoadingHorizontal, setIsLoadingHorizontal] = useState(true);
    const [isLoadingVertical, setIsLoadingVertical] = useState(true);

    const injectEmbed = (
        containerRef: React.RefObject<HTMLDivElement>,
        embedHtmlAsString: string,
        onLoad: () => void
    ) => {
        if (!containerRef.current) return;

        containerRef.current.innerHTML = "";

        const fragment = document
            .createRange()
            .createContextualFragment(embedHtmlAsString);

        const embedDiv = fragment.querySelector(
            ".dff402f7-5be0-4890-b831-95c5b63ddb42"
        ) as HTMLElement;

        if (embedDiv) {
            embedDiv.dataset.userid = user.userInfo?.User?.Details?.Id;
        }

        containerRef.current.appendChild(fragment);

        // Attach the load event listener
        const handleEmbedLoaded = () => {
            onLoad();

            // override collection configuration for use in dashboard
            const profileUpdate = {
                embedTextColor: "#000000",
                embedBackgroundColor: "#fafafa"
            };

            const embedInstances = [
                ...window.switcherPlayerApp?.playerCollection?.[
                    "278966ff-6e04-4dcb-880c-3b4e24663757"
                ],
                ...window.switcherPlayerApp?.playerCollection?.[
                    "025d1e42-efda-49a9-9d48-1dca78169954"
                ]
            ];

            embedInstances.forEach((instance) => {
                instance?.mainConnection?.setCollectionDetails(profileUpdate);
                instance?.auxConnection?.setCollectionDetails(profileUpdate);
            });
        };

        window.addEventListener("switcherPlayerAppLoaded", handleEmbedLoaded);

        return () => {
            window.removeEventListener(
                "switcherPlayerAppLoaded",
                handleEmbedLoaded
            );
        };
    };

    useEffect(() => {
        const horizontalEmbedHtml = `
                <div
                    class="dff402f7-5be0-4890-b831-95c5b63ddb42"
                    data-hostname="https://player.switcherstudio.com"
                    data-path="/embed"
                    data-videoplayerid="278966ff-6e04-4dcb-880c-3b4e24663757"
                    data-location="iframe"
                ></div>
                <script src="https://player.switcherstudio.com/embed.js"></script>
            `;

        const cleanupHorizontalEmbed = injectEmbed(
            horizontalEmbedRef,
            horizontalEmbedHtml,
            () => setIsLoadingHorizontal(false)
        );

        return cleanupHorizontalEmbed;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const verticalEmbedHtml = `
                <div
                    class="dff402f7-5be0-4890-b831-95c5b63ddb42"
                    data-hostname="https://player.switcherstudio.com"
                    data-path="/embed"
                    data-videoplayerid="025d1e42-efda-49a9-9d48-1dca78169954"
                    data-location="iframe"
                ></div>
                <script src="https://player.switcherstudio.com/embed.js"></script>
            `;

        const cleanupVerticalEmbed = injectEmbed(
            verticalEmbedRef,
            verticalEmbedHtml,
            () => setIsLoadingVertical(false)
        );

        return cleanupVerticalEmbed;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Loading isLoading={isLoadingHorizontal || isLoadingVertical} />
            <div ref={horizontalEmbedRef} />
            <div ref={verticalEmbedRef} />
        </div>
    );
};
